<template>
  <div
    v-click-outside="close"
    :class="$style.compare_dropdown"
    :style="disabled ? {opacity: '.5', pointerEvents: 'none'} : null"
  >
    <div
      :class="$style.wrapper"
    >
      <div :class="$style.label">
        {{ locales('group_by_label') }}:
      </div>
      <div
        v-for="(item, index) in selectedList"
        :class="$style.selected_chips"
        @click="onSelectGroup(item)"
      >
        <div
          :key="index"
          :class="$style.chip"
        >
          <div> {{ item.label }}</div>
          <svg-sprite
            :class="$style.icon"
            name="close-2"
            type="bold"
            color="#B2B2B2"
            :size="20"
          />
        </div>
      </div>
      <vgp-icon-button
        ref="showMenuButton"
        :class="$style.icon_button"
        :colors="buttonColors"
        :active="showMenu"
        :icon="{ name:'plus-1', size: 20, type: 'regular' }"
        @onClick="toggle"
      />
    </div>

    <div :class="[$select.select, $select.reports_toolbar]">
      <context-menu
        v-if="showMenu && groupList.length"
        :position="positionMenu"
        :class="$style.list"
        style="min-width: 215px"
      >
        <template #body>
          <div
            v-for="(item, index) in groupList"
            :key="index"
            :class="$select.menu_item"
            @click="onSelectGroup(item)"
          >
            {{ item.label }}
          </div>
        </template>
      </context-menu>
    </div>
  </div>
</template>

<script>
import vgpIconButton from '$$vueCmp/globalButton/withIcon/iconButton.vue';

export default {
  components: { vgpIconButton },
  props: {
    groupList: { type: Array, default: () => [] },
    selectedList: { type: Array, default: () => [] },
    disabled: { type: Boolean, required: false, default: false },
  },
  emits: {
    onOpen: null,
    onSelectGroup: Object,
  },
  data() {
    return {
      locales: __,
      showMenu: false,
      positionMenu: null,
      selectedType: null,
      buttonColors: {
        color: '#1565C0',
        labelColor: '#191919',
        activeColor: '#11519A',
        hoverBg: '#D0E0F2',
        activeBg: '#A1C1E6',
        activeHoverBg: '#A1C1E6',
      },
    };
  },
  computed: {
    label() {
      return this.menu.find(m => m.isActive).text;
    },
  },
  methods: {
    toggle() {
      this.showMenu = !this.showMenu;
      if (this.showMenu) {
        this.positionMenu = this.$refs.showMenuButton.$el
          ? this.$refs.showMenuButton.$el.getBoundingClientRect()
          : this.$refs.showMenuButton.getBoundingClientRect();
        this.$emit('onOpen');
      }
    },
    close() {
      this.showMenu = false;
    },
    onSelectGroup(item) {
      this.$emit('onSelectGroup', item);
      this.showMenu = false;
    }
  },
};
</script>

<style module lang='less'>
@import '../../../less/_fonts.less';
@import '../../../less/_mixins.less';

@iconColor: #333333;
@labelColor: #191919;
@activeColor: #1565C0;
@hoverBg: #F2F2F2;
@activeBg: #D0E0F2;
@activeHoverBg: #A1C1E6;

.compare_dropdown {
  .wrapper {
    display: flex;
    align-items: center;
    padding: 0 8px;

    .label {
      font-size: 12px;
      .FontLatoRegular;
      color: @labelColor;
      white-space: nowrap;
    }

    .selected_chips {
      display: flex;
      align-items: center;
      padding-left: 4px;

      .chip {
        display: flex;
        align-items: center;
        .FontLatoRegular;
        .fs(14px, 20px);
        color: #191919;
        padding: 2px 8px;
        background: #F2F2F2;
        border-radius: 12px;
        cursor: pointer;

        &:not(:last-child) {
          margin-right: 4px;
        }

        .icon {
          margin-left: 4px
        }
      }
    }

    .icon_button {
      margin-left: 4px;
    }
  }
}
</style>
<style module='$select' src="../../header/less/select.less"></style>
